import { Component , HostBinding } from '@angular/core';
import { TrackingDirective } from '../helpers/directive/tracking.directive';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    standalone: true,
    imports: [TrackingDirective]
})
export class ContactComponent {

  @HostBinding('style.width') public readonly WIDTH = '100%';

  title = 'webapp';
}
